var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-portlet',{attrs:{"title":"Timbre Releases","icon":""}},_vm._l((_vm.releases),function(release){return _c('collapse-portlet',{key:release.id,attrs:{"title":_vm.getReleaseTitle(release),"expanded":false,"icon":"flaticon2-rocket"}},[_c('release-content',{attrs:{"release":release}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }